import { useLocalization } from "@tm/localization"
import { Alert } from "@tm/controls"

export function NoDataWarningComponent() {
    const { translateText } = useLocalization()

    return <Alert icon="info" skin="warning" message={translateText(323)} />
}
